<ng-container *ngIf="state$ | async as state">
    <div class="recording-consent" *ngIf="state.consentRequest as request" role="alertdialog" aria-live="assertive"
         aria-labelledby="recording-consent-title" aria-describedby="recording-consent-body">
        <div class="recording-consent-icon" aria-hidden="true"><i class="fa-solid fa-circle-dot"></i></div>
        <div class="recording-consent-text">
            <ng-container *ngIf="!request.lateJoin; else lateJoin">
                <div class="recording-consent-title" id="recording-consent-title">{{ request.hostName || 'The host' }} wants to record this call</div>
                <div class="recording-consent-body" id="recording-consent-body">Recording starts only if everyone in the call allows it.</div>
            </ng-container>
            <ng-template #lateJoin>
                <div class="recording-consent-title" id="recording-consent-title">
                    {{ state.recording?.status === 'Recording' ? 'This call is being recorded' : 'This call is about to be recorded' }}
                </div>
                <div class="recording-consent-body" id="recording-consent-body">Allow the recording to join, or decline and stay out of the call.</div>
            </ng-template>
        </div>
        <button type="button" class="recording-consent-decline" (click)="onDecline()">
            {{ request.lateJoin ? "Don't join" : 'Decline' }}
        </button>
        <button #allowButton type="button" class="recording-consent-allow" (click)="onAllow()">
            {{ request.lateJoin ? 'Allow and join' : 'Allow' }}
        </button>
    </div>

    <ng-container *ngIf="state.phase === 'connected'">
        <div class="recording-indicator" *ngIf="state.recording?.status === 'Recording'" role="status" aria-label="This call is being recorded">
            <span class="recording-indicator-dot" aria-hidden="true"></span>
            <span>Recording</span>
        </div>
        <ng-container *ngIf="state.isCaller">
            <div class="recording-notice" *ngIf="state.recording?.status === 'Requested'" role="status" aria-live="polite">
                Waiting for everyone to allow recording…
            </div>
            <!-- A Cancelled with nobody named is the host's own withdrawal (ITP-E-189-06): nothing to tell them. -->
            <div class="recording-notice recording-notice-declined" role="alert"
                 *ngIf="state.recording?.status === 'Cancelled' && state.recording?.declinedBy">
                <span>{{ state.recording?.declinedBy }} declined recording. Nothing was recorded.</span>
                <button type="button" class="recording-notice-close" (click)="onDismissNotice()" aria-label="Close">
                    <i class="fa-solid fa-xmark"></i>
                </button>
            </div>
        </ng-container>
    </ng-container>
</ng-container>
